import { hash } from "rsvp";
import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class ServersRoute extends Route {
  @service availableServices;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "compute", "bare-metal");
  }

  model() {
    let { project } = this.modelFor("organization");
    return hash({
      servers: project.get("servers"),
      project,
    });
  }
}
